import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { CustomButton, Loading, TextInput } from "../components";
import { BsArrowLeft, BsShare } from "react-icons/bs";
import { BgImage } from "../assets";
import { ImConnection } from "react-icons/im";
import { AiOutlineInteraction } from "react-icons/ai";
import { apiRequest } from "../utils";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PasswordReset = () => {
  const [valid, setValid] = useState(false)
  const [errMsg, setErrMsg] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    mode: "onChange",
  });

  const password = useRef({});
  password.current = watch("password", "");
  const datas=useParams();

    const onSubmit = async (data) => {
        try {
          const { password, confirmPassword } = data;
      
          if (password !== confirmPassword) {
            setErrMsg("Passwords do not match");
            return;
          }
      
          const userId = datas.id; 
          const response = await apiRequest({
            url: "/users/reset-password",
            data:{userId, password},
            method: "POST",
          });
      
          if (response.ok) {
            toast.success("Password reset successful");
            window.location.href = "/";
          } else {
            alert("Password reset failed");
          }
        } catch (error) {
          console.error("Error resetting password:", error);
          alert("An error occurred while resetting the password");
        }
      };

        const checkResetTime = async () => {
            try {
                const userId = datas.id;
                const responses = await fetch('https://vkmedia-backend-updated-one.onrender.com/users/resetpasswordtimethere', {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ userId: userId })
              });
              if(responses.status===201){
                window.location.href = "/";
              }
            } catch (error) {
                console.error("Error checking password reset time:", error);
                alert("An error occurred while checking the password reset time");
            }
        };


        useEffect(() => {
          console.log("Under use effect")
          checkResetTime();
        }, [datas.id]);
      
    
  
      
  
  return (
    <div className='bg-bgColor w-full h-screen flex items-center justify-center p-6'>
        
      <div className='w-full md:w-2/3 h-fit lg:h-full 2xl:h-5/6 py-8 lg:py-0 flex bg-primary rounded-xl overflow-hidden shadow-xl'>
        <div className='w-full lg:w-1/2 h-full p-10 2xl:px-20 flex flex-col justify-center '>
          <div className='w-full flex gap-2 items-center mb-6'>
            <Link to='/login' className='p-2 bg-[#065ad8] rounded text-white'>
              <BsArrowLeft />
            </Link>
            <span className='text-2xl text-[#065ad8] font-bold'>Password Reset</span>
          </div>

          <p className='text-ascent-1 text-base font-semibold'>Reset your password</p>
          <span className='text-sm mt-2 text-ascent-2'>Enter your new password below</span>

          <form
            className='py-8 flex flex-col gap-5='
            onSubmit={handleSubmit(onSubmit)}
          >
            <TextInput
              name='password'
              placeholder='Enter your new password'
              label='New Password'
              type='password'
              register={register("password", {
                required: "New Password is required",
              })}
              styles='w-full rounded-full'
              labelStyle='ml-2'
              error={errors.password ? errors.password.message : ""}
            />

            <TextInput
              name='confirmPassword'
              placeholder='Confirm your new password'
              label='Confirm Password'
              type='password'
              register={register("confirmPassword", {
                required: "Confirm Password is required",
                validate: (value) =>
                  value === password.current || "The passwords do not match",
              })}
              styles='w-full rounded-full'
              labelStyle='ml-2'
              error={errors.confirmPassword ? errors.confirmPassword.message : ""}
            />

            {errMsg && (
              <span className="text-sm text-[#f64949fe] mt-0.5">{errMsg}</span>
            )}

            {isSubmitting ? (
              <Loading />
            ) : (
              <CustomButton
                type='submit'
                containerStyles={` inline-flex justify-center rounded-md bg-blue px-8 py-3 text-sm font-medium text-white outline-none mt-6`}
                title='Reset Password'
              />
            )}
          </form>
        </div>
        <div className='hidden w-1/2 h-full lg:flex flex-col items-center justify-center bg-blue'>
          <div className='relative w-full flex items-center justify-center'>
            <img
              src={BgImage}
              alt='Bg Image'
              className='w-48 2xl:w-64 h-48 2xl:h-64 rounded-full object-cover'
            />

            <div className='absolute flex items-center gap-1 bg-white right-10 top-10 py-2 px-5 rounded-full'>
              <BsShare size={14} />
              <span className='text-xs font-medium'>Share</span>
            </div>

            <div className='absolute flex items-center gap-1 bg-white left-10 top-6 py-2 px-5 rounded-full'>
              <ImConnection />
              <span className='text-xs font-medium'>Connect</span>
            </div>

            <div className='absolute flex items-center gap-1 bg-white left-12 bottom-6 py-2 px-5 rounded-full'>
              <AiOutlineInteraction />
              <span className='text-xs font-medium'>Interact</span>
            </div>
          </div>

          <div className='mt-16 text-center'>
            <p className='text-white text-base'>
              Connect with Freinds & Family.
            </p>
            <span className='text-sm text-white/80'>
              Share memories with friends and the world.
            </span>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default PasswordReset;